(ns app.survey.login.email-or-sms.sub
  (:require
   [common.util :as cu]
   [re-frame.core :as rf]))

(rf/reg-sub
 ::state
 (fn [db [_]]
   (get db ::state)))

(rf/reg-sub
 ::tries-left
 (fn [db _]
   (get db ::tries-left)))

(rf/reg-sub
 ::validated?
 (fn [db [_]]
   (get db ::validated?)))

(rf/reg-sub
 ::phone-validated?
 (fn [db [_]]
   (get db ::phone-validated?)))

(rf/reg-sub
 ::valid-phone?
 (fn [db]
   (get db ::valid-phone?)))

(rf/reg-sub
 ::phone
 (fn [db [_]]
   (get db ::phone)))

(rf/reg-sub
 ::masked-phone
 (fn [db [_]]
   (get db ::masked-phone)))


(rf/reg-sub
 ::masked-email
 (fn [db [_]]
   (get db ::masked-email)))


(rf/reg-sub
 ::email-token
 (fn [db [_]]
   (get db ::email-token)))

(rf/reg-sub
 ::sms-token
 (fn [db [_]]
   (get db ::sms-token)))

(rf/reg-sub
 ::valid-verification-tokens?
 :<-
 [::email-token]
 :<-
 [::sms-token]
 (fn [[email-token sms-token] _]
   (let [valid? (and (not (cu/blank-value? (str email-token)))
                     (not (cu/blank-value? (str sms-token))))]
     valid?)))



(rf/reg-sub
 ::valid-email-token?
 :<-
 [::email-token]
 (fn [email-token _]
   (not (cu/blank-value? (str email-token)))))

(rf/reg-sub
 ::valid-sms-token?
 :<-
 [::sms-token]
 (fn [sms-token _]
   (not (cu/blank-value? (str sms-token)))))
